<div id="divCreateJobWrapper">
  <div class="divProgressBar">
    <div class="divStep{{step}}of{{amountOfSteps}}"></div>
  </div>
  <div id="divStep1" class="divStep" *ngIf="step == 1">
    <form #locationForm="ngForm">
      <div class="divStepper">
        Stap {{step}} van {{amountOfSteps}}
      </div>
      <div class="divStepContent">
        <div id="job-location-information">
          <h3>Waar moet de opdracht worden uitgevoerd?</h3>
          <p class="adresSubHeader">Deze gegevens hebben we nodig zodat de vakmensen weten waar de opdracht plaatsvindt.</p>
          <section class="contactInputFields">
            <input type="text" required pattern="^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)([A-Z]{2}$|[a-z]{2}$)" placeholder="Postcode* (1234AB)" maxlength="6" address-autocomplete="postal"
              [(ngModel)]="postal" name="ipostal" (input)="checkAddress()" [ngClass]="{ 'stepTried' : nextStepTried}">
            <div class="houseNumber-wrapper">
              <input type="text" required placeholder="Huisnummer*" address-autocomplete="houseNumber"
                name="ihousenumber" [(ngModel)]="houseNumber" (input)="checkAddress()" [ngClass]="{ 'stepTried' : nextStepTried}">
              <input type="text" address-autocomplete="addition" placeholder="Toevoeging" name="iaddition" (input)="checkAddress()"
                [(ngModel)]="houseNumberAddition">
            </div>
            <input type="text" placeholder="Straat*" required address-autocomplete="street" [(ngModel)]="street" name="istreet" [ngClass]="{ 'stepTried' : nextStepTried}">
            <input type="text" placeholder="Stad*" required address-autocomplete="city" [(ngModel)]="city" name="icity" [ngClass]="{ 'stepTried' : nextStepTried}">
          </section>
        </div>
      </div>
      <div class="divStepButtons">
        <div *ngIf="nextStepTried" class="nextStepError">
          Vul alle verplichte velden in.
        </div>
        <input type="submit" (click)="nextStep(!(locationForm.invalid))" value="Volgende">
      </div>
      <div id="divFooter">
        <p id="parMandatoryFields">* zijn verplichte velden</p>
      </div>
    </form>
  </div>
  <div id="divStep2" class="divStep" *ngIf="step == 2">
    <form #detailForm="ngForm">
      <div class="divStepper">
        Stap {{step}} van {{amountOfSteps}}
      </div>
      <div class="divStepContent">

        <div id="job-information">
          <h3>Omschrijf je opdracht</h3>

          <input type="text" required="required" [(ngModel)]="title"
            placeholder="Titel* (b.v. Montage Ikea kast)"
            name="ititle"
            [ngClass]="{ 'stepTried' : nextStepTried}">
          <textarea id="descriptionArea" required="required" rows="5" [(ngModel)]="description" name="idescription" [ngClass]="{ 'stepTried' : nextStepTried}"
            placeholder="Omschrijving* (b.v. Ik wil mijn Ikea kast laten monteren en deze ook laten voorzien van verlichting)"></textarea>
          <span id="descriptionAreaContactInfoError" style="display: none ;">Omschrijving kan geen contact informatie
            bevatten</span>
        </div>
        <div id="job-details">
          <section>
            <h3>Wat zijn de formaten?</h3>
            <input type="number" required="required" placeholder="Breedte in cm*" [(ngModel)]="detailsLength"
              name="ilength" [ngClass]="{ 'stepTried' : nextStepTried}">
            <input type="number" required="required" placeholder="Diepte/ lengte in cm*" [(ngModel)]="detailsWidth"
              name="iwidth" [ngClass]="{ 'stepTried' : nextStepTried}">
            <input type="number" required="required" placeholder="Hoogte in cm*" [(ngModel)]="detailsHeight"
              name="iheight" [ngClass]="{ 'stepTried' : nextStepTried}">
            <div class="doorTypeWrapper">
              <label>
                <input type="radio" [(ngModel)]="radioDoorType" value="Geen" name="idoortype"> Geen deuren
              </label>
              <label>
                <input type="radio" [(ngModel)]="radioDoorType" value="Klapdeuren" name="idoortype"> Klapdeuren
              </label>
              <label>
                <input type="radio" [(ngModel)]="radioDoorType" value="Schuifdeuren" name="idoortype"> Schuifdeuren
              </label>
            </div>
          </section>
          <div class="extraWrapper">
            <h3>Zijn er nog extra elementen?</h3>
            <label>
              <input type="checkbox" [(ngModel)]="cbDrawers" name="idrawers"> Lades
            </label>
            <label>
              <input type="checkbox" [(ngModel)]="cbLights" name="ilights"> Verlichting
            </label>
            <label>
              <input type="checkbox" [(ngModel)]="cbExtra" name="iextra"> Extra's
            </label>
            <textarea [(ngModel)]="txtExtra" id="txtExtra" *ngIf="cbExtra" name="itextextra"></textarea>
          </div>
          <div id="job-date-information">
            <h3>Wanneer moet de klus worden gemonteerd?</h3>
            <span>Kies een datum en eventuele speling*</span>
            <input type="date" [(ngModel)]="dateExecution" id="dateExecution" required="required" name="idate" [ngClass]="{ 'stepTried' : nextStepTried}">
            <select [(ngModel)]="weekRange" name="iweek">
              <option value="">Op de datum zelf</option>
              <option value="1">+ 1 week</option>
              <option value="2">+ 2 weken</option>
              <option value="3">+ 3 weken</option>
              <option value="4">+ 4 weken</option>
              <option value="5">+ 5 weken</option>
            </select>
          </div>
        </div>
      </div>
      <div class="divStepButtons">
        <div *ngIf="nextStepTried" class="nextStepError">
          Vul alle verplichte velden in.
        </div>
        <div class="divPreviousStepButton" (click)="previousStep()">
          Terug
        </div>
        <input type="submit" (click)="nextStep(!!detailForm.valid)" value="Volgende">
      </div>
      <div id="divFooter">
        <p id="parMandatoryFields">* zijn verplichte velden</p>
      </div>
    </form>
  </div>
  <div id="divStep3" class="divStep" *ngIf="step == 3">
    <div class="divStepper">
      Stap {{step}} van {{amountOfSteps}}
    </div>
    <div class="divStepContent">
      <h3>Voeg hier een afbeelding toe van het product</h3>
      <span>Minimaal 1 afbeelding verplicht</span>
      <section class="wrapImageUpload">
        <span class="fileLabel">Bestand 1*</span>
        <input type="file" name="file1" accept="image/*" (change)="file1Change($event)">
        <img id="preview1" src="{{file1Preview}}">
      </section>

      <section class="wrapImageUpload" [hidden]="!file1">
        <span class="fileLabel">Bestand 2 (optioneel)</span>
        <input type="file" accept="image/*" (change)="file2Change($event)">
        <img id="preview2" src="{{file2Preview}}">
      </section>

      <span class="fileLabel">Handleiding (optioneel)</span>
      <input type="text" [(ngModel)]="manualUrl" placeholder="Link naar handleiding">
    </div>
    <div class="divStepButtons">
      <div *ngIf="nextStepTried" class="nextStepError">
        Voeg een afbeelding toe
      </div>
      <div class="divPreviousStepButton" (click)="previousStep()">
        Terug
      </div>
      <input *ngIf="amountOfSteps == 4" type="submit" (click)="nextStep(!!(guideProvided || manualUrl))" value="Volgende">
      <input *ngIf="amountOfSteps == 3" type="submit" (click)="createJob(!!(guideProvided || manualUrl))" value="Opdracht plaatsen">
    </div>
    <div id="divFooter">
      <p id="parMandatoryFields">* zijn verplichte velden</p>
    </div>
  </div>
  <div id="divStep4" class="divStep" *ngIf="step == 4">
    <div class="divStepper">
      Stap {{step}} van {{amountOfSteps}}
    </div>
    <div class="divStepContent">
      <div id="divNeedLogin" *ngIf="!user">
        <div id="divLogin">
          <form>
            <div id="divLogin">
              <h3>Heb je al een account ?</h3>
              <p class="loginDescription">Log hieronder in en plaats direct je klus</p>
              <input [(ngModel)]="loginUserName" placeholder="E-mailadres" name="iusername">
              <input type="password" [(ngModel)]="loginPassword" placeholder="Wachtwoord" name="ipassword">
              <input type="submit" (click)="login()" value="Login en plaats opdracht">
              <div id="divLoginFailed" *ngIf="loginFailed">Inloggen mislukt</div>
            </div>
          </form>
        </div>
        <div id="divRegister">
          <form #registerForm="ngForm">
            <h3>Geen account? Maak dan hier gratis je account aan</h3>
            <p class="loginDescription">Registreer je gratis en snel, plaats direct je klus.</p>
            <input [(ngModel)]="registerFirstName" name="iregisterFirstName" placeholder="Voornaam*" required="">
            <input [(ngModel)]="registerLastName" name="iregisterLastName" placeholder="Achternaam*" required="">
            <input [(ngModel)]="registerEmail" name="iregisterEmail" placeholder="E-mailadres*" (change)="checkMail()"
              required="">
            <span id="emailInUseError" *ngIf="emailInUse">Dit email adres is al in gebruik</span>
            <input [(ngModel)]="registerPassword" name="iregisterPassword" placeholder="Wachtwoord*" type="password"
              required="">
            <input [(ngModel)]="registerPasswordConfirm" name="iregisterPasswordConfirm" type="password"
              placeholder="Herhaal wachtwoord*" required="">
            <label>
              <input [(ngModel)]="registerAcceptTerms" type="checkbox" name="iregisterAcceptTerms" required="">
              Akkoord met de <a href="/voorwaarden" target="_blank">algemene voorwaarden</a>
            </label>
            <input type="submit" (click)="register()" value="Registreer en plaats opdracht"
              [disabled]="registerForm.invalid || emailInUse">
          </form>
        </div>
      </div>
      <div id="divLoggedIn" *ngIf="user">
        Ingelogd als {{user.email}}
      </div>
    </div>
    <div class="divStepButtons">
      <div class="divPreviousStepButton" (click)="previousStep()">
        Terug
      </div>
    </div>
    <div id="divFooter">
      <p id="parMandatoryFields">* zijn verplichte velden</p>
    </div>
  </div>
</div>